import { TAGLINE_SECONDARY } from '@/data/content';

export default function Marquee() {
  const items = `${TAGLINE_SECONDARY.replace(/•/g, '◆')} ◆ ARC TOONS ◆ `.repeat(4);
  return (
    <div
      data-testid="tagline-marquee"
      className="relative z-10 overflow-hidden border-y border-electric/15 bg-navy/70 py-4"
      style={{ backdropFilter: 'blur(8px)' }}
      aria-hidden="true"
    >
      <div className="flex w-max animate-marquee">
        <span className="whitespace-nowrap font-display text-sm font-semibold uppercase tracking-[0.35em] text-snow/70 sm:text-base">
          {items}
        </span>
        <span className="whitespace-nowrap font-display text-sm font-semibold uppercase tracking-[0.35em] text-snow/70">
          {items}
        </span>
      </div>
    </div>
  );
}
